export default {
    data () {
        return {
            transportDays: [
                { id: 1, label: 'จันทร์' },
                { id: 2, label: 'อังคาร' },
                { id: 3, label: 'พุธ' },
                { id: 4, label: 'พฤหัสบดี' },
                { id: 5, label: 'ศุกร์' },
                { id: 6, label: 'เสาร์' },
                { id: 7, label: 'ไม่แน่นอน' }
            ],
            onlineOperationStatus: [
                { status: 6, label: 'New' },
                { status: 7, label: 'Reject' },
                { status: 8, label: 'Complete' },
                { status: 9, label: 'Return' }

            ],
            onlineOperationTagList: [
                { id: 1, label: 'ยกเลิกหน้าสัญญา' },
                { id: 2, label: 'ยกเลิกหน้าราคาขนส่ง' },
                { id: 3, label: 'ยกเลิกหน้าข้อมูลการรับเข้าสินค้า' },
                { id: 4, label: 'ยกเลิกหน้าข้อมูลบัญชีธนาคาร' },
                { id: 5, label: 'ยกเลิกหน้าข้อมูลรูปบัตรประชาชน / ก.พ.20 ' },
                { id: 6, label: 'ยกเลิกหน้าข้อมูลรูปบัญชีธนาคาร' },
                { id: 7, label: 'ยกเลิกหน้ารอตรวจสอบ' }
            ]
        }
    },
    methods: {
        getTransportDay (id) {
            let hasDay = this.transportDays.filter((e) => { return e.id === parseInt(id) })
            if (hasDay.length > 0) {
                return hasDay[0].label
            } else {
                return ''
            }
        },
        getOnlineStatus (status) {
            let hasStatus = this.onlineOperationStatus.filter((e) => { return e.status === parseInt(status) })
            if (hasStatus.length > 0) {
                return hasStatus[0].label
            } else {
                return ''
            }
        },
        getOperationTag (tagId) {
            let hasTag = this.onlineOperationTagList.filter((e) => { return e.id === parseInt(tagId) })
            if (hasTag.length > 0) {
                return hasTag[0].label
            } else {
                return null
            }
        }
    }
}
